import React from 'react';
import { useHistory } from 'react-router-dom';
import { appRoutes } from '../../../routes/routes';
import { Text, textVariantsEnum, fontWeightEnum } from '@/components/Text';
import { QuickBooksCard } from './QuickBooksCard.component';
import styles from './QuickBooksDetailPage.module.scss';

export const QuickBooksDetailPage = () => {
  const history = useHistory();

  return (
    <div className={styles.page}>
      <button
        className={styles.backBtn}
        onClick={() => history.push(appRoutes().integrations)}
      >
        ← Back to Integrations
      </button>

      <div className={styles.pageHeader}>
        <div className={styles.headerLeft}>
          <div className={styles.logoMark}>QB</div>
          <div className={styles.titleBlock}>
            <Text
              variant={textVariantsEnum.Header}
              fontWeight={fontWeightEnum.Semibold}
            >
              QuickBooks Online
            </Text>
            <Text
              variant={textVariantsEnum.Text_13}
              fontWeight={fontWeightEnum.Normal}
              color="gray-600"
            >
              Export tracked time to QuickBooks Online as time activities for
              payroll and billing.
            </Text>
          </div>
        </div>
      </div>

      <div className={styles.panels}>
        <QuickBooksCard />
      </div>
    </div>
  );
};
